import React from 'react'
import styles from '../styles/main.module.css'

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      login: false,
    }
  }
  render() {
    const toggleLogin = () => this.setState({ login: !this.state.login })

    return (
      <div className={styles.app}>
        <Sidebar>
          <h1>l v ng</h1>
          <p>Grundstücksverwaltungs GmbH</p>
          <p>
            Westerberg 28<br />
            38173 Sickte
          </p>
          <button className={styles.toggle} onClick={toggleLogin}>
            Login
          </button>
          <br />
          <Impressum />
        </Sidebar>
        {this.state.login && <Login close={() => toggleLogin()} />}
      </div>
    )
  }
}

class Impressum extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      impressum: false,
      hover: false,
    }
  }
  setHover(hover) {
    this.setState({ hover })
  }
  toggleImpressum(impressum = !this.state.impressum) {
    this.setState({ impressum })
  }
  render() {
    const classes = [styles.impressum]
    const show = this.state.impressum || this.state.hover

    if (show) classes.push(styles.show)

    return (
      <div className={classes.join(' ')}>
        <button
          className={styles.toggle}
          onMouseOver={() => this.setHover(true)}
          onMouseOut={() => this.setHover(false)}
          onClick={() => this.toggleImpressum()}
        >
          Impressum
        </button>
        <div className={styles.impressumBody}>
          <h2>Geschäftsführer</h2>
          <p>Aaron Weithäuser</p>
          <p>Christian Peters</p>

          <h2>Firmenbuchgericht </h2>
          <p>Amtsgericht Braunschweig</p>

          <h2>Firmenbuch-Nr. </h2>
          <p>HRA 201800</p>

          <h2>Steuer-Nr.</h2>
          <p>13/201/50540</p>
        </div>
      </div>
    )
  }
}

const Sidebar = ({ children }) => (
  <div className={styles.sidebar}>{children}</div>
)

class Login extends React.Component {
  constructor() {
    super()
    this.state = { error: false }
  }
  onSubmit() {
    setTimeout(() => this.setState({ error: true }), 500)
  }
  render() {
    const close = this.props.close
    return (
      <div className={styles.loginContainer}>
        <div className={styles.loginBackground} onClick={close} />
        <div className={styles.login}>
          <button className={styles.close} onClick={close} />
          <Input label="Username" />
          <Input label="Password" />
          <button className={styles.submit} onClick={() => this.onSubmit()}>
            Login
          </button>
          {this.state.error && <span className={styles.error}>not found</span>}
        </div>
      </div>
    )
  }
}
const Input = ({ label }) => (
  <div className={styles.input}>
    <label>
      <input type="text" />
      {label}
    </label>
  </div>
)
export default App



// WEBPACK FOOTER //
// ./src/pages/index.js